import { Pagination } from '../pagination/pagination';
import { Review } from '../review/review';

export type ReviewsListProps = {
  reviews?: object[];
  updatePage: (page: number, rating: number | undefined) => void;
  rating?: number;
};

export const ReviewsList: React.FC<ReviewsListProps> = ({
  reviews,
  updatePage,
  rating,
}) => {
  const handlePageChange = (page: number) => {
    updatePage(page, rating);
  };

  return (
    <>
      <div className="flex flex-col gap-comfy-xl">
        {reviews?.map((review, index) => (
          <Review
            name={(review as { firstname: string }).firstname}
            sponsorDuration={(review as { Sponsor: string }).Sponsor}
            location={(review as { location: string }).location}
            reviewTitle={(review as { headline: string }).headline}
            rating={Number((review as { overall: string }).overall)}
            review={(review as { Comments: string }).Comments}
            recommendsCompassion={
              (review as { recommend: string }).recommend !== '0'
            }
            // eslint-disable-next-line react/no-array-index-key
            key={(review as { firstname: string }).firstname + index}
          />
        ))}
      </div>
      <Pagination
        totalItems={reviews?.length || 0}
        initialPage={0}
        itemsPerPage={10}
        onPageChange={(page) => handlePageChange(page)}
      />
    </>
  );
};
